/**
 * Constants used throughout the distribution page
 * Extracted from main distribution.page.ts for better organization
 */

// Default values
export const DEFAULT_FRONT_TEXT = 'GAVEKORT';

// Poll schedule (in seconds) — typically finishes in 1-3s, 10s at most.
// Aggressive early checks, then back off until the 25s deadline.
export const POLL_SCHEDULE = [2, 3, 5, 7, 8];
export const POLL_TIMEOUT = 15_000; // ms — per-request HTTP timeout (must be < POLL_TOTAL_TIMEOUT)
export const POLL_TOTAL_TIMEOUT = 25; // seconds — show retry button after this

// Storage keys used in localStorage
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'distributionAccessToken',
  ORDER_ID: 'distributionOrderId',
  PAYMENT_ID: 'paymentId',
  ORDER_EMAIL: 'orderEmail',
  DISTRIBUTION_DETAILS: 'distributionDetails',
  DESIGN_ID: 'designId',
  DESIGN_URL: 'designUrl',
  DESIGN_GREETING: 'designGreeting'
};

// Toast/Alert messages
export const MESSAGES = {
  LOGIN_ERROR: 'Vi kjenner dessverre ikke igjen denne kombinasjonen av e-post addresse og passord. Du finner riktig innlogging i e-post meldingen du fikk tilsendt sammen med kvitteringen for kjøpet',
  VALIDATION_ERROR_PREFIX: 'Det oppstod en feil, vennligst prøv igjen:\n  ',
  SESSION_EXPIRED: 'Økten har utløpt. Logg inn på nytt for å fortsette.',
};

// Max recipient name length, enforced on manual entry, paste-to-fill and file
// import alike. The SMS gateway truncates anything longer.
export const RECIPIENT_NAME_MAX_LENGTH = 30;

/**
 * The filled-in row the downloadable template ships so the expected format is
 * visible rather than described. Shared with the parser, which drops it on the
 * way back in: left in place it would import as a real recipient and spend a
 * gift card, and the SMS example is a dialable Norwegian number.
 */
export const TEMPLATE_EXAMPLE_RECIPIENT = {
  email: { name: 'Ola Nordmann', email: 'ola.nordmann@example.com' },
  sms: { name: 'Ola Nordmann', countryCode: '+47', phoneNumber: '99000000' },
} as const;
